const ADD_ITEM      = "ADD_ITEM";
const SET_POSITION  = "SET_POSITION";
const DELETE_POSITION  = "DELETE_POSITION";
const CHANGE_QUANTITY  = "CHANGE_QUANTITY";
const UPDATE_POSITIONS_LIST  = "UPDATE_POSITIONS_LIST";

const initialState = {
    staff: [
        {position_id:'', position_title:'', quantity:1}
    ],
    list:[]
};

/**
 * Start Callbacks
 **/

function addItem(state) {
    let stateCopy = {...state};
    if (stateCopy.staff.length < 30){
        stateCopy.staff.push(initialState.staff[0]);
    }
    return stateCopy;
}

function setPosition(state, e, { value, dataId }) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.staff[dataId].position_id = value;
    stateCopy.staff[dataId].position_title = e.target.innerText;
    return stateCopy;
}

function changeQuantity(state, dataId, act) {
    let stateCopy = {...state};
    let staff = {...stateCopy.staff};

    if (!staff[dataId].position_id) return stateCopy;

    if(act === 1 && staff[dataId].quantity < 50){
        staff[dataId].quantity++;
    }else if (act === 0 && staff[dataId].quantity > 1) {
        staff[dataId].quantity--;
    }

    return stateCopy;
}

function delPosition(state, dataId) {
    let stateCopy = {...state};
    if(stateCopy.staff.length > 1){
        stateCopy.staff.splice(dataId, 1);
    }

    return stateCopy;
}

function updatePositionsList(state, staff) {
    let stateCopy = {...state};
    let listOptions = [];
    Object.keys(staff.positions).forEach(function (key){
        listOptions.push(
            {
                key: staff.positions[key].position_id,
                text: staff.positions[key].profession_title,
                value: staff.positions[key].position_id
            }
        );
    });

    stateCopy.list = listOptions;
    return stateCopy;
}

/**
 * End of Callbacks
 **/

const teamReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ITEM:
            return addItem(state);
        case SET_POSITION:
            return setPosition(state, action.e, action.data);
        case CHANGE_QUANTITY:
            return changeQuantity(state, action.dataId, action.act);
        case DELETE_POSITION:
            return delPosition(state, action.dataId);
        case UPDATE_POSITIONS_LIST:
            return updatePositionsList(state, action.list);
        default:
            return state;
    }
};

/**
 * ACTIONS
 */

export function addItemAction() {
    return {type: ADD_ITEM};
}
export function setPositionAction(event, data) {
    return {type: SET_POSITION, e: event, data:data};
}
export function changeQuantityAction(dataId, act) {
    return {type: CHANGE_QUANTITY, dataId, act};
}
export function delPositionAction(dataId, act) {
    return {type: DELETE_POSITION, dataId, act};
}
export function updatePositionsListAction(list) {
    return {type: UPDATE_POSITIONS_LIST, list};
}

export default teamReducer;